import { gql } from '@apollo/client';

import useLazyQuery from 'api/hooks/useLazyQuery';
import permissions from 'api/Apollo/permissions';

import pipeline from './pipeline';

export const query = gql`
  query Pipeline($pipelineId: uuid!) {
    pipelines_by_pk(id: $pipelineId) {
      ...pipeline
    }
  }
  ${pipeline}
`;

export default function useLazyQueryPipeline({ ...options } = {}) {
  const [executeQuery, { data, ...rest }] = useLazyQuery(query, {
    context: { permission: permissions.readPipeline },
    ...options,
  });

  return [executeQuery, { data: data?.pipelines_by_pk, ...rest }];
}
